import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'ramda';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FORM_NAMES } from 'constants/forms';
import {
  ButtonWithLoader,
  Label,
  RFFormTextarea,
  RFFormRadioGroup,
  PaperContent,
} from 'virtues-bootstrap';
import validate from './validate';

const Feedback = ({ isPatient, handleSubmit, pristine, submitting, invalid, t }) => (
  <PaperContent>
    <form onSubmit={handleSubmit}>
      {isPatient && <p>{t('feedback.note')}</p>}
      <Label margin>{t('category')}</Label>
      <RFFormRadioGroup
        groupName="category"
        radioButtons={[
          { label: t('feedback.suggestion'), value: 'suggestion' },
          { label: t('feedback.error'), value: 'error' },
        ]}
      />

      <Field component={RFFormTextarea} label={t('message')} name="message" />

      <ButtonWithLoader disabled={invalid || pristine} loading={submitting} type="submit">
        {t('feedback.sendFeedback')}
      </ButtonWithLoader>
    </form>
  </PaperContent>
);

Feedback.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  isPatient: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

const withForm = reduxForm({
  form: FORM_NAMES.feedback,
  initialValues: {
    category: 'suggestion',
  },
  validate,
});

export default compose(
  withForm,
  withTranslation(),
)(Feedback);
